export const getDateFormat = (parseDate: string) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(parseDate)) {
        return "YYYY-MM-DD";
    }

    const arr = parseDate.split(".");

    if (arr.length !== 3) {
        throw new Error("Invalid date format. Expected format: DD.MM.YYYY, DD.MM.YY or YYYY-MM-DD");
    }

    const year = arr[arr.length - 1];

    if (year.length === 4) {
        return "DD.MM.YYYY";
    } else if (year.length === 2) {
        return "DD.MM.YY";
    } else {
        throw new Error("Invalid year format. Expected format: YYYY or YY");
    }
};
